/* tslint:disable */
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class HttpService {

    constructor(private http: HttpClient) {
    }


    getRequest(url: string, params?: HttpParams): Observable<any> {
        return this.http.get(url, { params: params, withCredentials: true });
    }

    postRequest(url: string, data: {}, options: any = {}): Observable<any> {
        return this.http.post(`${url}/`, data, { ...options, withCredentials: true });
    }

    putRequest(url: string, data: {}): Observable<any> {
        return this.http.put(`${url}/`, data, { withCredentials: true });
    }

    patchRequest(url: string, data: {}): Observable<any> {
        return this.http.patch(`${url}/`, data, { withCredentials: true });
    }

    deleteRequest(url: string): Observable<any> {
        return this.http.delete(`${url}/`, { withCredentials: true });
    }

    getMediaRequest(mediaUrl: string) {
        return this.http.get(environment.mediaURL + mediaUrl);
    }

}
